import {FC, useEffect, useState} from 'react'
import {getOrder} from "../../wordpress/operations/get-order";
import OrderRow from "./OrderRow";
import CampaignRow from "./CampaignRow";
import {resetBooking, storeBooking} from "../../lib/booking";
import {trackBookingComplete} from "../../lib/gtm";
import {CalendarArrowDown} from "lucide-react";
import {useNavigate} from "react-router-dom";

interface Props {
    booking: Booking
    pageContent: ContentPage,
    setBooking: Function
}

const ThankYou: FC<Props> = ({pageContent, booking, setBooking}) => {
    const [order, setOrder] = useState<any>(null);
    // Nyckeln sparas här eftersom booking nollställs när ordern hämtats
    const [orderKey] = useState(booking.order_key);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (!order) {
        getOrder(orderKey).then((val) => {
            setOrder(val)
            if (!val.error) {
                trackBookingComplete(val)
            }
            booking = resetBooking()
            booking.order_key = ''
            storeBooking(booking, setBooking)
            if (val.error === 'not_found') {
                navigate('/din-bil')
                return;
            }
        })
        return;
    }

    if (order.error) {
        return (
            <>
                <div className="row booking-banner_sub-header">
                    <div className="container">
                        <div className="col col-12">
                            <h1 className="booking_header_title">{pageContent.title}</h1>
                            <p className="booking_header_content">{order.title}</p></div>
                    </div>
                </div>
                <div id="wco-order-complete" className="container">
                    <div className="input-outer wco-booking-template-default woocommerce">
                        <div className="row">
                            <div className="order-error col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                                {order.message.map((item: any, i: number) => (
                                    <div>{item ? item : (<>&nbsp;</>)}</div>
                                ))}
                                <a className={"mt-5 btn btn-center btn--skyblue"} href={"/din-bil"}>Ny bokning</a>
                                <a className={"btn btn-center btn--secondary ml-2"}
                                   href={"https://mechanum.com"}>mechanum.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    // Calculate order sum
    let sum: number = 0;
    let sum_string: string = 'Pris offereras på mail efter bokning'
    for (let i = 0; i < order.items.length; i++) {
        if (order.items[i].is_price_visible) {
            sum += order.items[i].sale_price ? parseInt(order.items[i].sale_price) : parseInt(order.items[i].price)
        }
    }
    if (sum > 0)
        sum_string = (sum).toLocaleString('sv-SE') + ' kr'

    return (
        <>
            <div className="row booking-banner_sub-header">
                <div className="container">
                    <div className="col col-12">
                        {order.booking.booking_flow === 'hjulskifte' || order.booking.booking_flow === 'hjulskifte-arval' ? (
                            <>
                                <h1 className="mt-4 booking_header_title">Bokningsbekräftelse</h1>
                            </>
                        ) : (
                            <>
                                <h1 className="booking_header_title">{pageContent.title}</h1>
                                <p className="booking_header_content">Vi återkommer med bekräftelse av ditt
                                    besök</p>
                            </>
                            )}
                    </div>
                </div>
            </div>
            <div id="wco-order-complete" className="container">
                <div className="input-outer wco-booking-template-default woocommerce">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xxs-12">
                            <div className="woocommerce-order">
                                <ul className="woocommerce-order-overview woocommerce-thankyou-order-details order_details">
                                    <li className="woocommerce-order-overview__order order">Beställningsnummer: <strong>{order.order_number}</strong>
                                    </li>
                                    <li className="woocommerce-order-overview__date date">Beställningsdatum<strong>{order.date_created}</strong>
                                    </li>
                                    <li className="woocommerce-order-overview__email email">E-post: <strong>{order.email}</strong>
                                    </li>
                                </ul>
                                <table
                                    className="woocommerce-table woocommerce-table--order-details shop_table order_details">
                                    <tbody>
                                    <tr className="woocommerce-table__line-item order_item">
                                        <td className="woocommerce-table__product-name product-name"
                                            colSpan={2}>
                                            <div className="">
                                                <div>
                                                    <table className="wc-booking-summary-list"
                                                           style={{borderRadius: 0}}>
                                                        <tbody>
                                                        <tr>
                                                            <td style={{
                                                                padding: ".5em 0",
                                                                border: 0
                                                            }}>Bil:
                                                            </td>
                                                            <td style={{
                                                                padding: ".5em 0 .5em 1em",
                                                                border: 0
                                                            }} id="dlRegNr">{order.booking.car.brand} - {order.reg}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{
                                                                padding: ".5em 0",
                                                                border: 0
                                                            }}>Ärende:
                                                            </td>
                                                            <td style={{
                                                                padding: ".5em 0 .5em 1em",
                                                                border: 0
                                                            }}>
                                                                {order.service.name}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{
                                                                padding: ".5em 0",
                                                                border: 0
                                                            }}>Datum:
                                                            </td>
                                                            <td style={{
                                                                padding: ".5em 0 .5em 1em",
                                                                border: 0
                                                            }}>
                                                                {order.service.date}
                                                            </td>
                                                        </tr>
                                                        {order.service.time && (
                                                            <tr>
                                                                <td style={{
                                                                    padding: ".5em 0",
                                                                    border: 0
                                                                }}>Tid:
                                                                </td>
                                                                <td style={{
                                                                    padding: ".5em 0 .5em 1em",
                                                                    border: 0
                                                                }}>
                                                                    {order.service.time}
                                                                    {order.booking.submission.slug === "hamta-lamna" ? (
                                                                        <div>
                                                                            <div>Vi hämtar din bil, utför arbetet och kör sedan tillbaka den.</div>
                                                                            <div>Tiden är den planerade verkstadstiden. (Bilen hämtas alltså innan.)</div>
                                                                        </div>
                                                                    ) : ''}
                                                                </td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td style={{
                                                                padding: ".5em 0",
                                                                border: 0
                                                            }}>Plats:
                                                            </td>
                                                            <td style={{
                                                                padding: ".5em 0 .5em 1em",
                                                                border: 0
                                                            }}>
                                                                <div>Mechanum, {order.service.place.address}, {order.service.place.city}</div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    {order.items.map((item: any, i: number) => (
                                        <OrderRow key={i} item={item}/>
                                    ))}

                                    <tr className="woocommerce-table__line-item order_item price-visible">
                                        <td className="woocommerce-table__product-name product-name">
                                            <strong>Summa</strong><br/><small>{order.summary}</small>
                                        </td>
                                        <td className="woocommerce-table__product-total product-total">
                                                                <span
                                                                    className="woocommerce-Price-amount amount"><strong>{sum_string}</strong></span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                {order.rental_message && (
                                    <table
                                        className="woocommerce-table woocommerce-table--order-details shop_table order_details">
                                        <tbody>
                                        <tr className="woocommerce-table__line-item order_item campaign_row_header">
                                            <td colSpan={2}
                                                className="woocommerce-table__product-name product-name">Hyrbil
                                            </td>
                                        </tr>
                                        <CampaignRow name={order.rental_message}/>
                                        </tbody>
                                    </table>
                                )}

                                {(order.campaigns.length > 0 || order.booking.isLastMinute)  && (
                                    <table
                                        className="woocommerce-table woocommerce-table--order-details shop_table order_details">
                                        <tbody>
                                        <tr className="woocommerce-table__line-item order_item campaign_row_header">
                                            <td colSpan={2}
                                                className="woocommerce-table__product-name product-name">Kampanj
                                            </td>
                                        </tr>
                                        {order.booking.isLastMinute && (
                                            <CampaignRow name={order.booking.isLastMinuteMessage}/>
                                        )}
                                        {order.campaigns.map((campaign: any, i: number) => (
                                            <CampaignRow key={i} name={campaign.name}/>
                                        ))}
                                        </tbody>
                                    </table>
                                )}

                                <hr/>
                                <a className={"btn btn-center btn--skyblue"} href={"/din-bil"}>Ny bokning</a>
                                <a style={{paddingRight: '55px', position: 'relative'}}
                                   className={"btn btn-center btn--skyblue ml-2"}
                                   href={"https://boka.mechanum.com/ics?b=" + orderKey}>
                                    Ladda ner kalenderfil <CalendarArrowDown
                                    style={{position: 'absolute', right: '24px', top: '12px'}} height={20}/>
                                </a>
                                <a className={"btn btn-center btn--secondary ml-2"}
                                   href={"https://mechanum.com"}>mechanum.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default ThankYou
